import { Component } from "@/types/types"
import { cx } from "@/utils/cx"

export const COMPONENT_NAME = "title"

export const presets = {
  size: {
    xs: "text-base",
    sm: "text-lg",
    md: "text-xl",
    lg: "text-2xl",
    xl: "text-3xl",
  },
}

export interface Props extends Component {
  size: keyof typeof presets.size
  as?: "h1" | "h2" | "h3" | "div" | "p"
}

export function Title({
  as: Elem = "h1",
  size,
  children,
  className,
  testId = COMPONENT_NAME,
}: Props) {
  const resolvedSize = presets.size[size]

  return (
    <Elem
      className={cx("leading-snug font-semibold", resolvedSize, resolvedSize, className)}
      data-test={testId}
    >
      {children}
    </Elem>
  )
}
